<template>
    <ui-dialog
            :title="title"
            :isShow="isShowDalog"
            @closeDialog="closeDialog"
            @addOrEdit="submitForm"
    >
        <template #form>
            <el-form
                    ref="ruleFormRef"
                    :model="query"
                    :rules="rules"
                    label-width="80px"
            >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="地址名称" prop="remark">
                            {{query.title}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="类型" prop="remark">
                            {{query.category}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" prop="remark">
                            {{query.address}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="经纬度" prop="remark">
                            {{query.lngLat}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="图片列表" prop="remark">
                            <el-table

                                    border
                                    :data="imageList"
                            >
                                <el-table-column label="图片" prop="url">
                                    <template #default="scope">
                                        <el-image
                                                style="width: 50px; height: 50px;position: relative;z-index: 999"
                                                :src="scope.row.url"
                                                :zoom-rate="1.2"
                                                :max-scale="7"
                                                :min-scale="0.2"
                                                :z-index="99999"
                                                :preview-teleported="true"
                                                :preview-src-list="[scope.row.url]"
                                                :initial-index="0"
                                                fit="cover"
                                        />
                                    </template>
                                </el-table-column>
                                <el-table-column label="审核"  width="150">
                                    <template #default="scope">
                                     <el-button type="text" v-if="!scope.row.status" @click="changeImageStatus(scope.row,true)">启用</el-button>
                                     <el-button style="color: #f56c6c" type="text" v-if="scope.row.status" @click="changeImageStatus(scope.row,false)">禁用</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="用户反馈" prop="remark">
                            <el-card v-for="item in feedbackList" style="margin-right: 10px;margin-bottom: 10px">
                                <template #header>
                                    <div class="card-header">
                                       <div class="header-btn">
                                           <el-avatar
                                                   v-if="item.user.avtor"
                                                   style="position: relative;top: 8px"
                                                   :src="item.user.avtor"
                                           />
                                           <el-avatar
                                                   v-else
                                                   style="position: relative;top: 8px"
                                                   icon="UserFilled"
                                           />
                                       </div>
                                       <div class="feed-info">
                                           <div>
                                               <div>
                                                   <span>{{item.user.nickname}}</span>
                                               </div>
                                               <div>
                                                   <el-rate style="float: left" v-model="item.total_rate" disabled/>
                                                   <span class="feed-time">{{item.create_time}}</span>
                                               </div>
                                           </div>
                                       </div>

                                    </div>
                                </template>
                                <div>
                                    <el-form-item label="厕所状态">
                                        <span v-if="item.status==1">：正常使用</span>
                                        <span v-if="item.status==2">：未开放</span>
                                        <span v-if="item.status==3">：地点错误</span>
                                        <span v-if="item.status==4">：不存在</span>
                                        <span v-if="item.status==5">：收费使用</span>
                                    </el-form-item>
                                </div>
                                <div>
                                    <el-form-item label="卫生状况">
                                        <span v-if="item.level==1">：非常糟糕</span>
                                        <span v-if="item.level==2">：一般</span>
                                        <span v-if="item.level==3">：还不错</span>
                                        <span v-if="item.level==4">：干净</span>
                                        <span v-if="item.level==5">：非常干净</span>
                                    </el-form-item>
                                </div>
                            </el-card>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>

    </ui-dialog>
    <el-dialog
            v-model="dialogVisible"
            title="新增分组"
            width="30%"
    >
        <el-input v-model="groupType" placeholder="请输入分组名称"></el-input>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submit_handle_groupType">
                      确定
                    </el-button>
              </span>
        </template>
    </el-dialog>
</template>

<script setup>
    import {
        defineComponent,
        onMounted,
        defineExpose,
        ref,
        computed,
        toRefs,
        reactive,
        defineProps,
        defineEmits,
        nextTick
    } from 'vue'
    import { ElMessage } from "element-plus"
    import {createHandle,updateHandle,detailHandle} from '@/api/customer'
    import {getFeedBackList,getFeedBackListByToilet,changeToiletImageStatus} from '@/api/feedback'
    import {getProductList,createProTag,delProTagById,getProductTagTree,updateProTag} from '@/api/department'
    import {upload} from '@/api/upload'
    import ImageUploader from "quill-image-uploader";
    import {isPhone} from "../../utils/validate";
    const props = defineProps({
        isShow:{
            type:Boolean
        },
        title:{
            type:String,
            default:"详情"
        },
    })
    const hideUpload = ref(false)
    const isShowDalog = ref(false)
    let feedbackList = ref([])
    const imageList = ref([
        {
            url:"https://zhangliang-web.oss-cn-shanghai.aliyuncs.com/cms/news/oZy1eWfB88Tva4b222069654523b696c8f2731d69bac.png"
        }
    ])
    let query = reactive({
        id:undefined,
        lngLat:"",
        title:"",
        address:"",
        category:""
    })
    const valiPhone = (rule, value, callback) => {
        console.log(value)
        if(!isPhone(value)){
            callback(new Error('请输入正确的11位手机号'));
        }else{
            callback()
        }
    }
    const rules = reactive({
        fullName: [
            {
                required: true,
                message: '请输入客户全名',
                trigger: 'blur',
            },
        ],
        mobile: [
            {
                required: true,
                message: '请输入手机号',
                trigger: 'blur',
                validator:valiPhone

            }
        ],
        city: [
            {
                required: true,
                message: '请输入城市',
                trigger: 'blur',
            },
        ],
    })

    let isShowRight = ref(false)
    let getTreeRef = ref(null)
    const defaultProps = {
        children: 'children',
        label: 'name',
    }
    function selectParentEle(){
        isShowRight.value = true
    }
    function handleNodeClick(e){
        query.department_id = e.id
        query.departmentName = e.name
    }
    function closeRightHandle(){
        isShowRight.value = false
    }
    function openedDrawer(){
        getTreeRef.value.setCurrentKey(query.pid,true)
        nextTick(() => {
            getTreeRef.value.setCurrentKey(query.pid,true)
        })
    }
    let data = ref([])
    function getProductTagTreeHandle(){
        getProductTagTree().then(res=>{
            data.value = res.data
        })
    }
    const closeDialog = () => {
        emit("closeDialog")
    }
    const ruleFormRef = ref(null)
    const submitForm = () => {
        closeDialog()
    }
    function getImage(val){
        console.log(val)
        query.icon = val[0]
    }
    //编辑---初始化数据
    const init = (option) => {
        isShowDalog.value = props.isShow
        if(option.id){
            query.id = option.id
            query.title = option.title
            query.category = option.category
            query.address = option.address
            query.lngLat = option.lng+','+option.lat
            getImagesList(option.id)
            // "1092700743368098111" 可以测试的id
            getFeedBackListByToilet({id:option.id}).then(data => {
                feedbackList.value = data.data
            })
        }
    }


    function getImagesList(id){
        getFeedBackList({id:id}).then(data => {
            imageList.value = data.data
        })
    }
    let dialogVisible = ref(false)
    let groupType = ref("")
    let groupTypeArray = ref([])
    function groupType_handle(){
        console.log(111)
        dialogVisible.value = true
    }
    function submit_handle_groupType(){
        groupTypeArray.value.push(groupType.value)
        dialogVisible.value = false
    }
    function changeImageStatus(data,status){
        let obj = {
            id:data.id,
            status:status
        }
        changeToiletImageStatus(obj).then(data=>{
            if(data.code == 200){
                ElMessage({
                    showClose: true,
                    message: '更新成功',
                    type: 'success',
                })
                getImagesList(query.id)
            }

        })
    }
    //定义父组件需要调用的方法
    defineExpose({
        init
    })
    onMounted( () => {

    })
    const emit = defineEmits(["closeDialog","refreshDataList"])
</script>

<style lang="scss" scoped>
    .title{
        background: #ededed;
        padding: 10px 0;
        margin-bottom: 20px;
        p{
            width: 98%;
            margin: 0 auto;
        }
    }
    .editor{
        width: 100%;
    }
    .card-header{
        overflow: hidden;
        >div{
            float: left;
        }
        .header-btn{

        }
        .feed-info{
            >div{
                margin-left: 10px;
            }
            .feed-time{
                float: left;
                position: relative;
                top: -8px;
            }
        }
    }
</style>
